import { render, staticRenderFns } from "./ConsultarCita.vue?vue&type=template&id=0244a016&scoped=true"
import script from "./ConsultarCita.vue?vue&type=script&lang=js"
export * from "./ConsultarCita.vue?vue&type=script&lang=js"
import style0 from "./ConsultarCita.vue?vue&type=style&index=0&id=0244a016&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0244a016",
  null
  
)

export default component.exports